import React, {useContext} from 'react';
import Header from "../../../components/customer/ProductsCustomer/Header";
import Title from "../../../components/customer/ProductsCustomer/Title";
import Footer from "../../../components/customer/ProductsCustomer/Footer";
import car_icon from "../../../assets/images/car_icon.png";
import motorbike_icon from "../../../assets/images/motorbike_icon.png";
import house_icon from "../../../assets/images/house_icon.png";
import microseg_icon from "../../../assets/images/microseg_icon.png";
import others_icon from "../../../assets/images/others_icon.png";
import "../../customer/CustomerStyles.css"
import {useMediaQuery} from "react-responsive";
import HeaderMobile from "../../../components/customer/ProductsCustomer/Mobile/HeaderMobile";
import TitleMobile from "../../../components/customer/ProductsCustomer/Mobile/TitleMobile";
import ProductBannerMobile from "../../../components/customer/ProductsCustomer/Mobile/ProductBannerMobile";
import AffinityContext from "../../../context/AffinityContext";
import ProductBannerAlternative from "../../../components/customer/ProductsCustomer/ProductBannerAlternative";
import ProductBannerPrevencion from "../../../components/customer/ProductsCustomer/ProductBannerPrevencion";
import Grid from '@mui/material/Grid';

const ProductsCustomer = () => {

    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",
    });
    const {affinityProducts} = useContext(AffinityContext)

    const products = [
        {
            id: "0",
            productName: "AUTO",
            productIcon: car_icon,
        },
        {
            id: "1",
            productName: "MOTO",
            productIcon: motorbike_icon,
        },
        {
            id: "2",
            productName: "HOGAR",
            productIcon: house_icon,
        },
        {
            id: "3",
            productName: "MICROSEGUROS",
            productIcon: microseg_icon,
        },
        {
            id: "4",
            productName: "OTROS SEGUROS",
            productIcon: others_icon,
        },
        {
            id: "5",
            productName: "PREVENCION",
        },
    ];

    const productsToShow = (affinityProducts) => {
        let productsDOM = []

        if (affinityProducts.includes('0'))
            productsDOM.push(
                <Grid item xs={8}>
                    <ProductBannerAlternative
                        productName={products[0].productName}
                        productIcon={products[0].productIcon}
                    />
                </Grid>
            )
        if (affinityProducts.includes('1'))
            productsDOM.push(
                <Grid item xs={8}>
                    <ProductBannerAlternative
                        productName={products[1].productName}
                        productIcon={products[1].productIcon}
                    />
                </Grid>
            )
        if (affinityProducts.includes('2'))
            productsDOM.push(
                <Grid item xs={8}>
                    <ProductBannerAlternative
                        productName={products[2].productName}
                        productIcon={products[2].productIcon}
                    />
                </Grid>
            )
        if (affinityProducts.includes('3'))
            productsDOM.push(
                <Grid item xs={8}>
                    <ProductBannerAlternative
                        productName={products[3].productName}
                        productIcon={products[3].productIcon}
                    />
                </Grid>
            )
        if (affinityProducts.includes('4'))
            productsDOM.push(
                <Grid item xs={8}>
                    <ProductBannerAlternative
                        productName={products[4].productName}
                        productIcon={products[4].productIcon}
                    />
                </Grid>
            );
        if (affinityProducts.includes('5'))
            productsDOM.push(
                <Grid item xs={8}>
                    <ProductBannerPrevencion
                        productName={products[5].productName}
                        productIcon={products[5].productIcon}
                    />
                </Grid>
            );
        return productsDOM;
    }

    const productsToShowMobile = (affinityProducts, isMobile) => {
        let productsDOM = []

        if (affinityProducts.includes('0'))
            productsDOM.push(
                <div className="product-banner-column-mobile">
                    <ProductBannerMobile
                        productName={products[0].productName}
                        productIcon={products[0].productIcon}
                    />
                </div>
            )
        if (affinityProducts.includes('1'))
            productsDOM.push(
                <div className="product-banner-column-mobile">
                    <ProductBannerMobile
                        productName={products[1].productName}
                        productIcon={products[1].productIcon}
                    />
                </div>
            )
        if (affinityProducts.includes('2'))
            productsDOM.push(
                <div className="product-banner-column-mobile">
                    <ProductBannerMobile
                        productName={products[2].productName}
                        productIcon={products[2].productIcon}
                    />
                </div>
            )
        if (affinityProducts.includes('3'))
            productsDOM.push(
                <div className="product-banner-column-mobile">
                    <ProductBannerMobile
                        productName={products[3].productName}
                        productIcon={products[3].productIcon}
                    />
                </div>
            )
        if (affinityProducts.includes('4'))
            productsDOM.push(
                <div className="product-banner-column-mobile">
                    <ProductBannerMobile
                        productName={products[4].productName}
                        productIcon={products[4].productIcon}
                    />
                </div>
            )
        if (affinityProducts.includes('5'))
            productsDOM.push(
                <div className="product-banner-column-mobile">
                    <ProductBannerPrevencion
                        isMobile={isMobile}
                        productName={products[5].productName}
                        productIcon={products[5].productIcon}
                    />
                </div>
            );
        return productsDOM;
    }
    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    backgroundColor: "#F5F6F9",
                    height: "100vh"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%"
                    }}
                >
                    {isMobileDevice ? <HeaderMobile/> : <Header/>}
                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignSelf: "center",
                        width: "90%",
                        justifyContent: "start",
                        marginBottom: !isMobileDevice && "24px"
                    }}
                >
                    {isMobileDevice
                        ? <TitleMobile title={"SEGUROS"} subtitle={"Elegí el producto que necesitás:"}/>
                        : <Title title={"SEGUROS"} subtitle={"Elegí el producto que necesitás:"}/>}

                </div>
                <div>
                    {isMobileDevice
                        ? <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}>
                            {productsToShowMobile(affinityProducts, isMobileDevice)}
                        </div>
                        :
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                        }}>
                            <div>
                                {productsToShow(affinityProducts).map((renderData, i) =>
                                    i % 2 === 0 ? renderData : <></>)}
                            </div>
                            <div>
                                {productsToShow(affinityProducts).map((renderData, i) =>
                                    i % 2 === 1 ? renderData : <></>)}
                            </div>
                        </div>
                    }
                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "8px",
                        paddingBottom: "48px"
                    }}
                >
                    <Footer/>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ProductsCustomer;
